import { useState, useEffect } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setCrmManagements } from 'redux/features/crmManagements/crmManagementsSlice'
import {  roleIds } from 'utils/Constants'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import moment from 'moment'
import { getPermission } from 'utils/Auth'
import { setUsers } from 'redux/features/users/usersSlice'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from 'components/loader/Spinner'
import Tooltip from 'components/tooltip/Tooltip'
import { Dropdown } from 'primereact/dropdown'

const CrmPage = () => {
	const [filterOptions, setFilterOptions] = useState({  searchString: '', status: null, am: [] })
	const [createModal, setCreateModal] = useState({ open: false, crmManagement: {} })
	const [accountManagers, setAccountManagers] = useState([])
	const { crmManagements } = useSelector((state) => state)
	const { crmManagementsData } = crmManagements
	const [getCrmManagements, getCrmManagementsLoading] = useRequest()
	const [addCrmManagement] = useRequest()
	const { showToast } = useToast()
	const dispatch = useDispatch()
	const [getUsers] = useRequest()
	const navigate = useNavigate()
	const hasCrmPermission = getPermission('CrmManagement.read')
	const [sectors, setSectors] = useState([])

	useEffect(() => {
		if (!hasCrmPermission) {
			navigate('/')
		}
	}, [hasCrmPermission])

	if (!hasCrmPermission) {
		return null
	}

	useEffect(() => {
		if (!createModal.open) {
			getCrmManagements('/CrmManagement/GetAllCrmManagements', { method: 'GET'}).then(
				(res) => {
					if (res.data.ok) {
						dispatch(
							setCrmManagements(
								res.data.result.map((c) => ({
									...c,
									crmRoles: c.crmRoles ? c.crmRoles.filter(
										(r) =>
											!r.endDate ||
											(r.endDate &&
												moment(new Date(), 'YYYY-MM-DD').diff(moment(r.endDate).format('YYYY-MM-DD'), 'days') < 1)
									) : [],
								}))
							)
						)
					}
				}
			)
		}
        // Get sectors from API
        getUsers('/CrmManagement/GetCrmCompanySectors', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setSectors(res.data.result.map((s) => ({ label: s.name, value: s.id })))
            }
        })
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setUsers(res.data.result))
			}
		})
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
			params: {
				isDeleteFilter: true
			}
		}).then((res) => {
			if (res.data.ok) {
				setAccountManagers(res.data.result.filter(r => r.roles.map(r => r.id).includes(roleIds.accountManager) ))
			}
		})
	}, [createModal, filterOptions.isArchive])

	useEffect(() => {
		// CRM doesn't need developers, this can be removed or replaced with CRM-specific data
	}, [])

	const handleAddCrmManagement = () => {
		if (!createModal?.crmManagement?.newCrmCompanyName) {
			showToast('Kurumsal Adı Girin', 'error')
		} else if (!createModal?.crmManagement?.crmCompanySectorId && !createModal?.crmManagement?.newCrmCompanySectorName) {
			showToast('Sektör Seçin', 'error')
		} else if (!createModal?.crmManagement?.accountManagerUserIds || createModal?.crmManagement?.accountManagerUserIds.length === 0) {
			showToast('Account Manager Seçin', 'error')
		} else {
			const postData = {
				id: 0,
				crmCompanyId: 0,
				newCrmCompanyName: createModal.crmManagement.newCrmCompanyName,
				crmCompanySectorId: createModal.crmManagement.crmCompanySectorId || 0,
				newCrmCompanySectorName: createModal.crmManagement.newCrmCompanySectorName || "",
				webSiteUrl: createModal.crmManagement.webSiteUrl || "",
				status: 1,
				accountManagerUserIds: createModal.crmManagement.accountManagerUserIds
			}
			
			addCrmManagement('/CrmManagement/UpsertCrmManagement', {
				method: 'POST',
				data: postData,
			}).then((res) => {
				if (res.data) {
					showToast('CRM Kaydı Oluşturuldu', 'success')
					setCreateModal({ open: false, crmManagement: {} })
				}
			})
		}
	}
	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}

	}
	
	const filteredCrmManagements = [...crmManagementsData]
	?.sort((a, b) => {
		const nameA = (a.crmCompanyName || '').toLowerCase();
		const nameB = (b.crmCompanyName || '').toLowerCase();
		return nameA.localeCompare(nameB, 'tr');
	})
	?.filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k] != null && filterOptions[k] !== '' && !(Array.isArray(filterOptions[k]) && filterOptions[k].length === 0)) {
					if (k == 'searchString') {
						let uniName = (d.crmCompanyName || '').toLocaleLowerCase('tr')
						rt.push(uniName.includes(filterOptions[k].toLocaleLowerCase('tr')))
					} else if (k == 'sector') {
						rt.push(filterOptions[k].map((e) => e.value).includes(d.crmCompanySectorId))
					} else if (k == 'status') {
						rt.push(d.status === filterOptions[k])
					} else if (k == 'am') {
						const selectedAmIds = filterOptions[k].map((e) => e.value)
						const hasMatchingAm = d.crmAccountManagers?.some(am => selectedAmIds.includes(am.accountManagerUserId))
						rt.push(hasMatchingAm)
					} else {
						rt.push(d.id == filterOptions[k])
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	const accountManagerOptions = accountManagers.map((am) => ({ label: `${am.firstName} ${am.lastName}`, value: am.id }))
	// CRM doesn't need special coloring like projects
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getCrmManagementsLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<div className='row'>
					<DataTable
						stripedRows
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						header={() => (
							<div className='d-flex justify-content-between gap-3'>
								<div className='row flex-1'>
									<div className='col-md-2 pl-0'>
										<span className='p-input-icon-left '>
											<i className='pi pi-search' />
											{filterOptions.searchString && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
											<input
												type='text'
												placeholder='Kurumsal Adı'
												className='default-input pl-5 pr-4'
												value={filterOptions.searchString}
												name='searchString'
												onChange={(e) => handleChnage(e.target, 'searchString')}
											/>
										</span>

									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												setFilterOptions(prev => ({ ...prev, am: e || [] }))
											}
											value={filterOptions.am}
											placeholder='Account Manager'
											isSearchable
											isMulti
											isClearable
											selectOptions={accountManagers.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((s) => ({ ...s, name: 'sector' })),
													'sector',
													true
												)
											}
											placeholder='Sektör'
											isSearchable
											isMulti
											selectOptions={sectors}
										/>
									</div>
									<div className='col-md-2'>
										<DefaultSelect
											placeholder='Durum'
											value={filterOptions.status !== null ? 
												[{ label: filterOptions.status === 1 ? 'Aktif' : 'Pasif', value: filterOptions.status }] : null}
											selectOptions={[
												{ label: 'Aktif', value: 1 },
												{ label: 'Pasif', value: 0 },
											]}
											handleChange={(e) => setFilterOptions(prev => ({ ...prev, status: e ? e.value : null }))}
											isClearable
										/>
									</div>
									
								</div>
								<div className='filters-right'>
									{getPermission('CrmManagement.create') && (
										<Button handleClick={() => setCreateModal({ open: true, crmManagement: {}})} className='btn-success' title='Yeni Müşteri Ekle' icon={<Icons.plus />} />
									)}
								</div>
							</div>
						)}
						rowClassName={`cursor-pointer table-hover `}
						rowExpansionTemplate={() => <div>Expansion</div>}
						onRowClick={(e) => {
							navigate(`${e.data.id}`)
						}}
						value={filteredCrmManagements}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: '30%', position: 'relative', padding: '8px', }}
							field='crmCompanyName'
							header='Kurumsal Adı'
							sortable='true'
							body={(rowData) => {
								return (
									<div className='text-sm'>
										<Tooltip textClass='bottom' text={rowData.crmCompanyName} >
											<div className='text-elipsis'>{rowData.crmCompanyName}</div>
										</Tooltip>
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: '25%', position: 'relative', padding: '8px' }}
							field='sector'
							header='Sektör'
							body={(rowData) => {
								const sectorLabel = sectors.find(s => s.value === rowData.crmCompanySectorId)?.label || rowData.crmCompanySectorName || 'Belirtilmemiş'
								return (
									<div className='text-sm text-primary'>
										{sectorLabel}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='status'
							header='Durum'
							style={{ width: '10%' }}
							body={(rowData) => {
								const statusLabel = rowData.status === 1 ? 'Aktif' : 'Pasif'
								const statusClass = rowData.status === 1 ? 'text-success' : 'text-danger'
								return (
									<div className={`text-sm ${statusClass}`}>
										<strong>{statusLabel}</strong>
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-sm'
							field='crmAccountManagers'
							header='AM'
							style={{ width: '25%' }}
							body={(rowData) => {
								return (
									<div className='text-sm'>
										{rowData.crmAccountManagers ? rowData.crmAccountManagers?.map((r) => `${r.accountManagerName}`).join(', ') : 'Belirtilmemiş'}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-sm relative-cell'
							style={{ width: '15%', position: 'relative', padding: '8px' }}
							field='createdAt'
							header='Oluşturulma Tarihi'
							body={(rowData) => {
								return (
									<div className='text-sm'>
										<Link target='_blank' className='new-page-link-icon' to={`${rowData.id}`}>
											<span>Yeni Pencerede Aç</span>{' '}
											<span onClick={(e) => e.stopPropagation()}>
												<Icons.arrowRight onClick={(e) => e.stopPropagation()} />
											</span>
										</Link>
										{moment(rowData.createdAt).format('DD/MM/YYYY')}
									</div>
								)
							}}
						/>
					</DataTable>
				</div>
			)}
			<Dialog
				style={{ width: '50%', height: '' }}
				header='Yeni Müşteri Ekle'
				draggable={false}
				visible={createModal.open}
				onHide={() => setCreateModal({ open: false, crmManagement: {} })}
			>
				<div className='w-100'>
					<div className='w-100 d-flex flex-column gap-3'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Kurumsal Adı *</label>
									<input
										className='default-input'
										type='text'
										placeholder='Kurumsal Adı'
										maxLength={200}
										value={createModal.crmManagement?.newCrmCompanyName || ''}
										onChange={e => {
											setCreateModal((prev) => ({
												...prev,
												crmManagement: {
													...prev.crmManagement,
													newCrmCompanyName: e.target.value
												}
											}))
										}}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Sektör *</label>
									<Dropdown value={createModal.crmManagement?.crmCompanySectorId || createModal.crmManagement?.newCrmCompanySectorName}
									onChange={e => {
										if (!e.originalEvent) return
										let isId = Number.isInteger(e.value) && sectors.find(s => s.value === e.value)
										setCreateModal((prev) => ({
											...prev,
											crmManagement: {
												...prev.crmManagement,
												crmCompanySectorId: isId ? e.value : null,
												newCrmCompanySectorName: isId ? null : e.value
											}
										}))
									}}
									onInput={e => {
										setCreateModal((prev) => ({ 
											...prev, 
											crmManagement: { 
												...prev.crmManagement, 
												crmCompanySectorId: null, 
												newCrmCompanySectorName: e.target.value 
											} 
										}))
									}}
									options={sectors}
									optionLabel='label'
									optionValue='value'
									placeholder={'Sektör'}
									filter
									filterLocale='tr'
									editable
									filterInputAutoFocus={false}
									className={'w-100'}
								/>
								</div>
							</div>
						</div>
					
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Account Manager *</label>
									<DefaultSelect
									isClearable
									isSearchable
									isMulti
									handleChange={(e) => {
										console.log(e, "E");
										setCreateModal((prev) => ({
											...prev,
											crmManagement: { 
												...prev.crmManagement, 
												accountManagerUserIds: e ? e.map(am => am.value) : []
											},
										}))
									}}
									placeholder='Account Manager'
									selectOptions={accountManagerOptions}
									value={createModal.crmManagement?.accountManagerUserIds ? 
										accountManagerOptions.filter(am => createModal.crmManagement.accountManagerUserIds.includes(am.value)) : []}
								/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Web Site URL</label>
									<input
									className='default-input'
									type='url'
									placeholder='Web Site URL'
									maxLength={200}
									value={createModal.crmManagement?.webSiteUrl || ''}
									onChange={e => {
										setCreateModal((prev) => ({
											...prev,
											crmManagement: {
												...prev.crmManagement,
												webSiteUrl: e.target.value
											}
										}))
									}}
								/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12 d-flex justify-content-end gap-3'>
								<Button className='btn-danger' title='Vazgeç' handleClick={() => setCreateModal({ open: false, crmManagement: {} })} />
								<Button className='btn-success' title='Kaydet' handleClick={handleAddCrmManagement} />
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</AnimatedSpan>
	)
}
export default CrmPage
